"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveAndCallStrategy;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _resolveStrategy = _interopRequireDefault(require("./resolveStrategy"));

function resolveAndCallStrategy(_x, _x2, _x3) {
  return _resolveAndCallStrategy.apply(this, arguments);
}

function _resolveAndCallStrategy() {
  _resolveAndCallStrategy = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ctx, strategyType, strategy) {
    var _yield$resolveStrateg,
        _yield$resolveStrateg2,
        handler,
        args,
        _len,
        otherArgs,
        _key,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _resolveStrategy.default)(ctx, strategyType, strategy);

          case 2:
            _yield$resolveStrateg = _context.sent;
            _yield$resolveStrateg2 = (0, _slicedToArray2.default)(_yield$resolveStrateg, 2);
            handler = _yield$resolveStrateg2[0];
            args = _yield$resolveStrateg2[1];

            for (_len = _args.length, otherArgs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
              otherArgs[_key - 3] = _args[_key];
            }

            return _context.abrupt("return", handler.apply(void 0, [ctx].concat(otherArgs, (0, _toConsumableArray2.default)(args))));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolveAndCallStrategy.apply(this, arguments);
}